/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 11.マーカーレスAR */
export const template11 = {
  title: t.to('マーカーなしのAR', 'title11'),
  desc: t.to(
    'マーカーなしでARを作ることもできます。シーンにARの設定用属性を設定して物体を配置してみましょう。',
    'desc11'
  ),
  img: '../public/template/11_noimage.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" x="50" y="110">
    <value name="ATTR">
      <block type="ar_scene_setting_attribute_v2">
        <field name="debugUIEnabled">false</field>
      </block>
    </value>
    <statement name="IN">
      <block type="sphere_v2">
        <field name="id">block1</field>
        <field name="position-x">0</field>
        <field name="position-y">0</field>
        <field name="position-z">0</field>
        <value name="COLOUR">
          <shadow type="color_value_v2">
            <field name="COLOUR">#ff0000</field>
          </shadow>
        </value>
      </block>
    </statement>
  </block>
</xml>`,
};
